import React, { useEffect } from 'react';
import styles, { mainCls } from './styles';
import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName/index';
import Grid from '../../Grid';
import GridItem from '../../GridItem';
import { Icon } from 'shared-vectors';
import CloseL from 'shared-vectors/icons/CloseL';

const useStyles = createStyle(styles);

const HeaderTooltipQRCode = ({ content, visible: showTooltip, hideTooltip }) => {
  const cls = useStyles();
  const toolTipCls = makeClassName([
    cls[mainCls],
    showTooltip && cls[`${mainCls}__visible`],
  ]);

  const handleClickOutside = (event) => {
    if (showTooltip && !event.target.closest(`.${mainCls}`)) {
      hideTooltip();
    }
  };

  useEffect(() => {
    let clickHandlerTimeout;

    if (showTooltip) {
      clickHandlerTimeout = setTimeout(() => {
        window.addEventListener('click', handleClickOutside);
      }, 0);
    }
  
    return () => {
      clearTimeout(clickHandlerTimeout);
      window.removeEventListener('click', handleClickOutside);
    };
  }, [showTooltip]);

  return (
    <Grid className={toolTipCls} noWrap direction="column">
      <GridItem className={`${cls[`${mainCls}__upper_cnt`]} mb--s`}>
        <p className="tp-s--s tp-w--m c-txt--f0">
          Inquadra il codice con la fotocamera per vedere questa pagina sul tuo telefono.
        </p>
        <div onClick={() => hideTooltip()} className={`${cls[mainCls]}__text c-txt--f0` }>
          <Icon className={`${cls[mainCls]}__header_close`} 
            name={CloseL} 
            width="16px" 
            height="16px"
          />
        </div>
      </GridItem>
      <GridItem className="c-txt--f0">
      {content}
      </GridItem>
    </Grid>
  );
};

export default HeaderTooltipQRCode;
